var _defs, _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconWebProgressArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .progress_arrowfill {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "progress_arrowfill",
    d: "M10.71,16.66c0-.97.38-1.9,1.08-2.57L22.38,3.67c1.45-1.43,3.77-1.43,5.22,0l10.59,10.41c1.42,1.39,1.44,3.67.05,5.09-.02.02-.03.03-.05.05-.7.69-1.64,1.08-2.62,1.07H14.38c-.98,0-1.92-.38-2.61-1.07-.69-.67-1.08-1.6-1.07-2.56Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "progress_arrowfill",
    cx: 24.99,
    cy: 28.11,
    r: 5.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "progress_arrowfill",
    cx: 24.99,
    cy: 41.65,
    r: 5.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconWebProgressArrowLine);
export default __webpack_public_path__ + "static/media/cloud_icon_web_progress_arrow_line.cfe00d8b15d39bbd55d37f5af82963c6.svg";
export { ForwardRef as ReactComponent };